import React from "react";

import './FlexContainer.css'

export default function FlexContainer(props) {
  return (
    <div className='flex-container'>
      {props.children}
    </div>  
  )
}
